import { Box, IconButton, Tooltip, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import React from "react";

import { copyToClipboard } from "../../utils";
import useStyles from "./OrderRow.styles";

/**
 * Linha de pedido reutilizada pelas tabelas do dashboard (OrdersTable e
 * WithdrawalAlert). A primeira coluna é sempre o ID, exibido com botão de
 * copiar; as demais colunas são renderizadas como texto. O layout de grid
 * (gridTemplateColumns) vem do `className` passado pelo componente pai.
 */
export default function OrderRow({ className, columns, onClick }) {
	const classes = useStyles();

	const { id, externalCode, waiting, client, delivery, salesChannel } = columns;
	const rest = salesChannel ? { waiting, client, salesChannel, delivery } : { waiting, client, delivery };
	const restKeys = Object.keys(rest);

	return (
		<Box
			className={`${className} ${classes.clickableRow}`}
			onClick={() => onClick(id)}
		>
			<Typography className={`${classes.tableCell} ${classes.idCell}`}>
				{externalCode}
				<IconButton
					className={classes.copyButton}
					onClick={(event) => {
						event.stopPropagation();
						copyToClipboard(externalCode);
					}}
					aria-label={`Copiar pedido ${id}`}
				>
					<Tooltip title="Copiar" placement="top">
						<FileCopyOutlinedIcon className={classes.copyIcon} />
					</Tooltip>
				</IconButton>
			</Typography>
			{restKeys?.map((key) => (
				<Typography className={classes.tableCell} key={key}>
					{rest?.[key]}
				</Typography>
			))}
			<ChevronRightIcon className={classes.rowArrow} />
		</Box>
	);
}
